<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>资讯管理/活动管理</span>
			</div>
			<div>
				<el-form
					:inline="true"
					:model="searchInfo"
					class="demo-form-inline margin_top_20 margin_left_20"
				>
					<el-form-item label="标题或 ID">
						<el-input
							class="custom_input_170"
							v-model="searchInfo.admin_keyword"
							placeholder="请输入活动标题或 ID"
						></el-input>
					</el-form-item>
					<el-form-item label="活动状态">
						<el-select v-model="searchInfo.activity_status" placeholder="全部">
							<el-option label="全部" value="" />
							<el-option label="草稿" value="draft" />
							<el-option label="审核中" value="reviewing" />
							<el-option label="审核未通过" value="review_rejected" />
							<el-option label="未开始" value="not_started" />
							<el-option label="进行中" value="ongoing" />
							<el-option label="已结束" value="ended" />
						</el-select>
					</el-form-item>
					<el-form-item label="活动类型">
						<el-select v-model="searchInfo.event_category" placeholder="全部">
							<el-option label="全部" value="" />
							<el-option label="Web3" value="web3" />
							<el-option label="AI" value="ai" />
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset">重置</el-button>
						<el-button v-if="canAddActivity" type="success" @click="toAddActivity">
							添加活动
						</el-button>
						<el-button v-if="canAddActivity" @click="lumaDialogVisible = true">
							活动导入
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData" @refresh="getDataList"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
		<el-dialog title="Luma 活动导入" :visible.sync="lumaDialogVisible" width="520px" @closed="lumaUrl = ''">
			<el-input v-model.trim="lumaUrl" placeholder="请输入 Luma 链接，目前仅支持 Luma 活动" @keyup.enter.native="importLuma" />
			<span slot="footer">
				<el-button @click="lumaDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="lumaImporting" :disabled="lumaImporting" @click="importLuma">
					{{ lumaImporting ? "导入中..." : "确定" }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import { activitylists, importLumaActivityV2 } from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	components: { tablec },
	mixins: [searchMixin],
	name: "",
	data() {
		return {
			title: "活动新增",
			tableData: [],
			total: 0,
			searchInfo: {
				page: 1,
				size: 10,
				admin_keyword: "",
				activity_status: "",
				event_category: "",
			},
			lumaDialogVisible: false,
			lumaUrl: "",
			lumaImporting: false,
		};
	},
	created() {
		this.getDataList();
	},
	computed: {
		canAddActivity() {
			const rolePermissions = this.$store.state.user.user.role_permissions;
			if (!rolePermissions) return false;
			return rolePermissions.split(",").map(Number).includes(403);
		},
	},
	methods: {
		toAddActivity() {
			this.$router.push("/event/addevent");
		},
		importLuma() {
			if (!/^https?:\/\/(?:www\.)?(?:lu\.ma|luma\.com)\//i.test(this.lumaUrl)) {
				this.$message.error("请输入正确的 Luma 活动链接");
				return;
			}
			this.lumaImporting = true;
			importLumaActivityV2({ url: this.lumaUrl }).then((res) => {
				if (res.code !== 200) return;
				if (res.data.exists) {
					this.$confirm("该活动已存在，是否前往编辑？", "提示", {
						confirmButtonText: "前往编辑",
						cancelButtonText: "取消",
					}).then(() => this.$router.push({ path: "/event/addevent", query: { id: res.data.id } })).catch(() => {});
					return;
				}
				sessionStorage.setItem("event_v2_luma_import", JSON.stringify(res.data.activity));
				this.$router.push({ path: "/event/addevent", query: { imported: "luma" } });
			}).catch(error => this.$message.error(error.message || "导入失败，请稍后重试")).finally(() => {
				this.lumaImporting = false;
			});
		},
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		getDataList() {
			activitylists(this.searchInfo)
				.then((res) => {
					if (res.code == 200) {
						console.log(res.data.total);

						this.tableData = res.data.list;
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped></style>
